import { useOutletContext } from 'react-router-dom'

import {
  SoftwareManagementCardFragment,
  SoftwareManagementExchangeCurrencyFragment,
  SoftwareManagementMonthlySoftwareCost,
  SoftwareManagementSoftwareSetupItemFragment,
} from 'generated/resources/graphql'

export interface ApplicationDetailsRouterOutletContextParams {
  softwareSetup: SoftwareManagementSoftwareSetupItemFragment
  card: SoftwareManagementCardFragment | null | undefined
  canManagePurchaseFinancialDocuments: boolean
  currency: string
  softwareCosts: SoftwareManagementMonthlySoftwareCost[]
  currencies: SoftwareManagementExchangeCurrencyFragment[]
}

export const useApplicationDetailsRouterParams = () =>
  useOutletContext<ApplicationDetailsRouterOutletContextParams>()
